import React, { createContext, useContext, useMemo, useRef, useState, useCallback } from 'react';

const styles = {
	container: {
		position: 'fixed',
		top: '100px',
		left: '50%',
		transform: 'translateX(-50%)',
		zIndex: 2000,
	},
	toast: {
		background: '#111',
		color: '#fff',
		padding: '12px 20px',
		borderRadius: '12px',
		boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
		fontSize: '14px',
		maxWidth: '520px',
		minWidth: '320px',
		textAlign: 'center',
	},
};

const SystemMessageContext = createContext({
	showMessage: () => {},
	hideMessage: () => {},
});

export function SystemMessageProvider({ children }) {
	const [message, setMessage] = useState('');
	const [visible, setVisible] = useState(false);
	const timerRef = useRef(null);

	const hideMessage = useCallback(() => {
		setVisible(false);
		setMessage('');
		if (timerRef.current) {
			clearTimeout(timerRef.current);
			timerRef.current = null;
		}
	}, []);

	const showMessage = useCallback(
		(text, duration = 2000) => {
			setMessage(text);
			setVisible(true);
			if (timerRef.current) {
				clearTimeout(timerRef.current);
			}
			timerRef.current = setTimeout(() => {
				hideMessage();
			}, duration);
		},
		[hideMessage],
	);

	const value = useMemo(() => ({ showMessage, hideMessage }), [showMessage, hideMessage]);

	return (
		<SystemMessageContext.Provider value={value}>
			{children}
			{visible && (
				<div style={styles.container}>
					<div style={styles.toast}>{message}</div>
				</div>
			)}
		</SystemMessageContext.Provider>
	);
}

export function useSystemMessage() {
	return useContext(SystemMessageContext);
}
